import { Injectable } from '@angular/core';

@Injectable()
export class ThemeService {

  private current: string;
  private themes: Array<string> = ['lightTheme', 'darkTheme', 'orangeTheme'];

  get theme() {
    return this.current;
  }

  initTheme() {
    if (this.current === undefined) {
      this.current = JSON.parse(localStorage.getItem('theme')) || this.themes[0];
    }

    if (this.current) {
      this.setTheme(this.current);
    }
  }

  changeTheme(name) {
    if (this.themes.indexOf(name) >= 0) {
      this.setTheme(name);
    } else {
      this.clean();
    }
  }

  private clean() {
    for (const theme of this.themes) {
      document.documentElement.classList.remove(theme);
    }
  }

  private setTheme(name) {
    localStorage.setItem('theme', JSON.stringify(name));

    this.clean();
    document.documentElement.classList.add(name);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/theme.service.ts